export default __webpack_public_path__ + "static/media/Map Screenshot.bc35945f.png";